// KamSathi Brand Assets
// Logo and written name used across all screens

// Import your actual logo files
// These will be placed in public/assets/ folder

export const BRAND = {
  // Paths to your logo files in public folder
  logoIcon: '/assets/KS_Logo.jpg',        // the KS icon logo
  logoText: '/assets/Written_KamSathi.jpg', // the "KamSathi" written name

  // App name
  appName: 'KamSathi',
  appSubName: 'Admin Panel',
  appNameHindi: 'कामसाथी',
  tagline: 'Har Kaam Ke Liye Aapka Saathi',

  // Favicon
  favicon: '/assets/KS_Logo.jpg',
};